import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import { AppDispatch, RootState } from '../../../redux/store';
import { generateManageApiKey } from "../../../redux/actions/apiKeys.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import KeyActionModal from "../../../components/common/KeyActionModal";
import { clearError } from "../../../redux/reducers/manageApiKeys.reducer";
import { withDefaultType } from "../params";

const GenerateManageKeyModal: React.FC<ModalProps> = ({ open, setOpen, object }) => {
  const searchParams = useSearchParams()[0];
  const dispatch = useDispatch<AppDispatch>();
  const { error, loading } = useSelector((state: RootState) => state.manageApiKeys);

  return (
    <KeyActionModal
      open={open}
      setOpen={setOpen}
      title={`Generate API key for ${object?.spaName ?? object?.spaSerial ?? object?.spaGuid}?`}
      body="A new bearer key will be issued for this spa."
      actionLabel="Generate"
      loadingLabel="Generating..."
      loading={loading}
      error={error}
      clearError={() => dispatch(clearError())}
      onConfirm={async () => {
        const action = await dispatch(generateManageApiKey({
          spaGuid: object?.spaGuid,
          params: withDefaultType(searchParams),
        }));
        return generateManageApiKey.fulfilled.match(action) ? action.payload?.apiKey ?? null : null;
      }}
    />
  );
};

export default GenerateManageKeyModal;
